import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import api from "../../api.js";
import ConfirmModal from "../ConfirmModal/ConfirmModal.js";
import './Iterazioni.css';

const Iterazioni = () => {
  const navigate = useNavigate();
  const [clienti, setClienti] = useState([
    {
      id: 1,
      cliente: 'Revo Insurance',
      referente: 'Andrea Rossi',
      ruoloReferente: 'Project Manager',
      emailReferente: 'andrea.rossi@revo.it',
      telReferente: '+39 02 1234567'
    }
  ]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterQuery, setFilterQuery] = useState('');
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const navigateTo = (path) => {
    navigate(path);
  };

  const requestDelete = (c) => {
    setDeleteTarget({
      id: c.id,
      _id: c._id,
      name: c.cliente || `Cliente #${c.id}`
    });
  };

  const confirmDelete = () => {
    if (!deleteTarget) return;
    deleteRow(deleteTarget.id, deleteTarget._id);
    setDeleteTarget(null);
  };

  const addCliente = () => {
    const clientiCopy = [...clienti];
    const newId = clientiCopy.length > 0 ? Math.max(...clientiCopy.map(c => c.id)) + 1 : 1;
    const newCliente = {
      id: newId,
      cliente: 'Nuovo Cliente ' + newId,
      referente: 'Nome Referente',
      ruoloReferente: 'Ruolo',
      emailReferente: 'mail@cliente.it',
      telReferente: '+39 02 0000000',
      modify: true,
      new: true,
      createdBy: localStorage.getItem('email'),
      edit: false,
      user: localStorage.getItem('email')
    };
    clientiCopy.unshift(newCliente);
    setClienti(clientiCopy);
  };

  const esportTabella = () => {
    const clientiCopy = [...clienti];
    const clientiExport = clientiCopy.map(({ id, cliente, referente, ruoloReferente, emailReferente, telReferente }) => 
      ({ id, cliente, referente, ruoloReferente, emailReferente, telReferente })
    );
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(clientiExport, null, 2));
    const downloadAnchor = document.createElement('a');
    downloadAnchor.setAttribute("href", dataStr);
    downloadAnchor.setAttribute("download", `clienti_export_${new Date().toISOString().slice(0,10)}.json`);
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    downloadAnchor.remove();
  };

  const changeVal = (id, field, value) => {
    const clientiCopy = [...clienti];
    const index = clientiCopy.findIndex((c) => c.id === id);
    if (index !== -1) {
      clientiCopy[index][field] = value;
      setClienti(clientiCopy);
    }
  };

  const modifyRow = (id) => {
    const clientiCopy = [...clienti];
    const index = clientiCopy.findIndex((c) => c.id === id);
    if (index !== -1) {
      clientiCopy[index].modify = !clientiCopy[index].modify;
      clientiCopy[index].edit = true;
      setClienti(clientiCopy);
    }
  };

  const deleteRow = (id, _id) => {
    const clientiCopy = [...clienti];
    const index = clientiCopy.findIndex((c) => c.id === id);
    if (index !== -1) {
      clientiCopy.splice(index, 1);
      axios.post(`${api()}/credenziali/deleteCredenziali`, {
        id: _id,
        headers: {
          authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then((res) => console.log(res))
      .catch((err) => console.error(err));

      setClienti(clientiCopy);
    }
  };

  const saveDataFromApi = (data, path) => {
    axios.post(`${api()}/credenziali/${path}`, {
      data: data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then((res) => {
      setLoading(false);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    })
    .catch((err) => {
      console.error(err);
      setError(err);
      setLoading(false);
    });
  };

  const saveProject = () => {
    const clientiCopy = [...clienti];
    const clientiNew = [];
    const clientiModify = [];

    clientiCopy.forEach((p) => {
      if (p.new) {
        const { id, cliente, referente, ruoloReferente, emailReferente, telReferente, createdBy, user } = p;
        clientiNew.push({ id, cliente, referente, ruoloReferente, emailReferente, telReferente, createdBy, user });
      } else if (p.edit) {
        const { _id, id, cliente, referente, ruoloReferente, emailReferente, telReferente, user } = p;
        clientiModify.push({ _id, id, cliente, referente, ruoloReferente, emailReferente, telReferente, user });
      }
    });

    if (clientiNew.length > 0) {
      saveDataFromApi(clientiNew, 'createCredenziali');
    }
    if (clientiModify.length > 0) {
      saveDataFromApi(clientiModify, 'updateCredenziali');
    }
  };

  const filterRow = (value) => {
    setFilterQuery(value);
  };

  const filteredClienti = clienti.filter(c => {
    if (!filterQuery.trim()) return true;
    const q = filterQuery.toLowerCase();
    return (
      (c.cliente && c.cliente.toLowerCase().includes(q)) ||
      (c.referente && c.referente.toLowerCase().includes(q)) ||
      (c.ruoloReferente && c.ruoloReferente.toLowerCase().includes(q)) ||
      (c.emailReferente && c.emailReferente.toLowerCase().includes(q)) ||
      (c.telReferente && c.telReferente.toLowerCase().includes(q))
    );
  });

  return (
    <div id="iterazioni-main" className="progetti-page">
      <div className="page-header">
        <div className="header-title">
          <h1>Clienti & Iterazioni Agile</h1>
          <span className="count-badge">{clienti.length} Clienti</span>
        </div>
      </div>

      <div className="progetti-action-bar progetti-cont-btn">
        <button onClick={addCliente} className='btn-action primary'>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          Nuovo Cliente
        </button>

        <button onClick={() => navigateTo('/dashboardIterazioni')} className='btn-action secondary'>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
          Board Kanban Iterazioni
        </button>
        
        <button onClick={esportTabella} className='btn-action secondary'>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
          Esporta JSON
        </button>

        <button className='btn-action success' onClick={saveProject}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
          Salva Modifiche
        </button>

        <div className="search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <input 
            type="text" 
            className="find" 
            placeholder="Filtra clienti..." 
            value={filterQuery}
            onChange={(e) => filterRow(e.target.value)}
          />
        </div>
      </div>

      {saveSuccess && (
        <div className="toast-success">
          ✓ Dati salvati con successo!
        </div>
      )}

      <div className="progetti-table-card">
        <div className="progetti-table-wrapper">
          <table className="progetti-table">
            <thead>
              <tr>
                <th style={{ width: '90px' }}>Modifica</th>
                <th style={{ width: '100px' }}>Elimina</th>
                <th style={{ width: '50px' }}>ID</th>
                <th>Cliente / Compagnia</th>
                <th>Referente</th>
                <th>Ruolo</th>
                <th>Email Referente</th>
                <th>Telefono</th>
                <th style={{ width: '120px' }}>Board</th>
              </tr>
            </thead>
            <tbody>
              {filteredClienti.length === 0 ? (
                <tr>
                  <td colSpan="9" className="empty-table">Nessun cliente registrato</td>
                </tr>
              ) : (
                filteredClienti.map((c) => (
                  <tr key={c.id} className={c.modify ? 'row-editing' : ''}>
                    <td>
                      <button 
                        onClick={() => modifyRow(c.id)} 
                        className={`btn-table-edit ${c.modify ? 'editing' : ''}`}
                      >
                        {c.modify ? 'Fatto' : 'Edit'}
                      </button>
                    </td>

                    <td>
                      <button onClick={() => requestDelete(c)} className="btn-table-del-btn" title="Elimina Cliente">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                        Elimina
                      </button>
                    </td>

                    <td className="cell-id">#{c.id}</td>

                    {c.modify ? (
                      <>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(c.id, 'cliente', e.target.value)} value={c.cliente || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(c.id, 'referente', e.target.value)} value={c.referente || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(c.id, 'ruoloReferente', e.target.value)} value={c.ruoloReferente || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(c.id, 'emailReferente', e.target.value)} value={c.emailReferente || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(c.id, 'telReferente', e.target.value)} value={c.telReferente || ''} /></td>
                      </>
                    ) : (
                      <>
                        <td className="cell-title">{c.cliente}</td>
                        <td className="cell-bold">{c.referente}</td>
                        <td><span className="badge-subtle">{c.ruoloReferente}</span></td>
                        <td className="cell-muted">{c.emailReferente}</td>
                        <td className="cell-muted">{c.telReferente}</td>
                      </>
                    )}

                    <td>
                      <button onClick={() => navigateTo('/dashboardIterazioni')} className="btn-action-kanban" title="Visualizza Board Iterazioni">
                        Iterazioni
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <ConfirmModal 
        isOpen={!!deleteTarget}
        title="Conferma Eliminazione Cliente"
        message={`Sei sicuro di voler eliminare il cliente "${deleteTarget?.name}"?`}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </div>
  );
};

export default Iterazioni;


